/**
 *  表单验证相关的校验工具
 */

import {
  isEmailValid,
  isHttpAddrValid,
  // isPhoneValid
  isPassword
} from '@/utils/validator.js'

export let validatorPhone = (rule, value, callback) => {
  if (!rule.required && (value === undefined || value === '')) {
    callback()
    return
  }
  // 特殊处理  手机号格式化之后跳过校验
  if (value.substr(3, 5) === '*****') {
    callback()
    return
  }
  if (isNaN(+value)) {
    return callback(new Error(window.vm.$t('common.phoneValid')))
  }

  let handle = ['-', '+', '.']
  let copyValue = value + ''
  handle.forEach(item => {
    if (copyValue.indexOf(item) !== -1) {
      return callback(new Error(window.vm.$t('common.phoneValid')))
    }
  })

  if (copyValue.length > 11) {
    return callback(new Error(window.vm.$t('common.maxPhoneLen')))
  }
  // if (!(copyValue.length > 7 && copyValue.length < 12)) {
  //   return callback(new Error(window.vm.$t('common.phoneValid')))
  // }

  callback()
  // let valid = isPhoneValid(+value)
  // if (!valid) {
  //   callback(new Error(window.vm.$t('common.phoneValid')))
  // } else {
  //   callback()
  // }
}

export let validatorHttpAddr = (rule, value, callback) => {
  if (!rule.required && value === undefined) {
    callback()
    return
  }
  let valid = isHttpAddrValid(value)
  if (!valid) {
    callback(new Error(window.vm.$t('common.httpValid')))
  } else {
    callback()
  }
}
// 校验非空
export let validatorEmpty = (rule, value, callback) => {
  if (value === undefined || value === '' || value === null) {
    callback(new Error(window.vm.$t('common.isNoEmpty')))
  } else {
    callback()
  }
}

// 校验邮箱
export let validatorEmail = (rule, value, callback) => {
  if (!rule.required && (value === undefined || value === '')) {
    callback()
    return
  }
  // 特殊处理 邮箱格式化后跳过校验
  if (value.substr(2, 3) === '***' || value.substr(1, 3) === '***') {
    callback()
    return
  }
  let valid = isEmailValid(value)
  if (!valid) {
    callback(new Error(window.vm.$t('common.emailValid')))
  } else {
    callback()
  }
}

// 校验字符串长度范围
export let validatorStringRange = (rule, value, callback) => {
  let { min, max } = rule
  if (value === undefined) {
    value = ''
  }
  let len = value.length
  if (len < min || len > max) {
    callback(
      new Error(
        window.vm.$t('common.stringInRange', {
          start: min,
          end: max
        })
      )
    )
  } else {
    callback()
  }
}

// 校验密码
export let validatorPassword = (rule, value, callback) => {
  if (!rule.required && (value === undefined || value === '')) {
    callback()
    return
  }
  let valid = isPassword(value)
  if (!valid) {
    callback(new Error(window.vm.$t('account.mustContain')))
  } else {
    callback()
  }
}



// WEBPACK FOOTER //
// ./src/utils/validatorFrom.js